import React, { useContext } from 'react';
import { Link, Typography } from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { setEditEvent } from '../../utils/analytics';
import { StaticField } from '../shared/static-field/static-field';
import { SectionHeader } from '../shared/section-header/section-header';
import { useProfile } from '../../hooks/use-profile';
import { TAX_EXEMPT_ID_PAGE_PATH } from '../../constants/links';
export var TaxExempt = function () {
    var _a;
    var profileValues = useProfile();
    var isConsumerApp = useContext(ExperienceContext).isConsumerApp;
    var title = (React.createElement(React.Fragment, null,
        "Home Depot ",
        React.createElement("br", null),
        "Tax Exempt ID"));
    var link = (React.createElement("span", { onClick: function () { return setEditEvent('profile page: link', 'tax exempt id page'); }, role: "link", tabIndex: 0 },
        "Visit our",
        ' ',
        React.createElement(Link, { "data-testid": "tax-id-lnk", href: TAX_EXEMPT_ID_PAGE_PATH },
            ' ',
            "Tax Exempt ID page",
            ' '),
        "for more information and to register."));
    return (React.createElement("div", null,
        React.createElement(SectionHeader, { title: "TAX EXEMPT ID" }),
        ((_a = profileValues.customerData) === null || _a === void 0 ? void 0 : _a.taxExemptId) ? (React.createElement(React.Fragment, null,
            React.createElement(StaticField, { title: title, content: profileValues.customerData.taxExemptId }),
            React.createElement(Typography, { variant: "body-base", weight: "regular" }, !isConsumerApp && link))) : (React.createElement(Typography, { variant: "body-base", weight: "regular" },
            "You don't have a Home Depot Tax Exempt ID associated with this account. ",
            !isConsumerApp && link))));
};
